<template>
  <div class="pt-3">
    <div class="d-flex justify-center">
      <div class="half_w">
        <v-card class="rounded-lg pa-3" flat>
          <title-page title="Settings" />
          <v-card outlined class="pa-3 mt-3 rounded-lg">
            <b>Change Password</b>
            <form @submit.prevent="changePwd">
              <v-text-field
                v-model="password"
                :error-messages="PasswordError"
                label="Password"
                :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show ? 'text' : 'password'"
                color="#377F65"
                @click:append="show = !show"
                @input="$v.password.$touch()"
                @blur="$v.password.$touch()"
              ></v-text-field>

              <v-text-field
                v-model="repwd"
                :error-messages="repwderr"
                label="Confirm password"
                :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show2 ? 'text' : 'password'"
                color="#377F65"
                @click:append="show2 = !show2"
                @input="$v.repwd.$touch()"
                @blur="$v.repwd.$touch()"
              ></v-text-field>
              <div class="d-flex justify-end">
                <v-btn
                  class="btn"
                  type="changePwd"
                  v-if="!loading"
                  color="#006341"
                  depressed
                  dark
                >
                  Save
                </v-btn>
                <v-btn
                  class="btn"
                  depressed
                  v-if="loading"
                  color="#006341"
                  dark
                >
                  Saving...
                </v-btn>
              </div>
            </form>
            <div class="d-flex justify-end"></div>
          </v-card>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import { mapState } from "vuex";
import TitlePage from "../../components/atom/titlePage.vue";
import { validationMixin } from "vuelidate";
import { required, minLength, sameAs } from "vuelidate/lib/validators";
export default {
  name: "changePwd",
  mixins: [validationMixin],
  validations: {
    password: { required, minLength: minLength(8) },
    repwd: { required, sameAsPassword: sameAs("password") },
  },
  components: {
    TitlePage,
  },
  computed: {
    ...mapState({
      permissions: (state) => state.permissions,
      role: (state) => state.role,
      id: (state) => state.id,
    }),
    PasswordError() {
      const errors = [];
      if (!this.$v.password.$dirty) return errors;
      !this.$v.password.minLength &&
        errors.push("Password minimum 8 characters!");
      !this.$v.password.required && errors.push("Password is required!");
      return errors;
    },
    repwderr() {
      const errors = [];
      if (!this.$v.repwd.$dirty) return errors;
      !this.$v.repwd.sameAsPassword &&
        errors.push("Password confirmation doesn't match!");
      !this.$v.repwd.required && errors.push("Password is required!");
      return errors;
    },
  },
  data() {
    return {
      loading: false,
      dataSet: null,
      password: "",
      repwd: "",
      show: false,
      show2: false,
    };
  },
  mounted() {},
  methods: {
    changePwd() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        let role = "";
        switch (this.role) {
          case "SCHOLAR":
            role = "scholar";
            break;
          case "VENDOR":
            role = "vendor_user";
            break;
          case "TF":
            role = "tf";
            break;
        }
        let body = {
          id: this.id,
          password: this.password,
        };
        this.loading = true;
        let data = {
          body: body,
          path: `manage/${role}/update`,
        };
        this.$store
          .dispatch("user/postApi", data)
          .then((data) => {
            this.$store.dispatch("notify", {
              msg: data.message,
              type: "success",
            });
            Cookies.remove("token");
            Cookies.remove("permissions");
            Cookies.remove("scholar");
            Cookies.remove("reset_pwd");
            localStorage.clear();
            this.$router.go("/login");
          })
          .catch((e) => {
            this.$store.dispatch("notify", {
              msg: e.message,
              type: "error",
            });
            this.loading = false;
          });
      }
    },
  },
};
</script>

<style scoped>
.input_green {
  border: 2px solid var(--g);
  border-radius: 5px;
  padding: 0 0 0 30px;
  height: 38px;
  background: #fff;
  width: 100%;
}
.input_green:focus {
  outline: none;
}
.magnify {
  margin-right: -30px;
}
</style>
